// extracted by mini-css-extract-plugin
export default {"truncate":"items-table_truncate__0JYKO","wrap":"items-table_wrap__9qGMV"};